import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import zyl_util_vue from 'zyl-util-vue'

import router from '@/router/index.js'
import store from '@/store/index.js'

import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.css'
import '@/assets/styles/public.css'
import '@/assets/styles/base.css'
import "@/assets/styles/layout.css"
import "@/assets/styles/adaptive.css"


Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
Vue.use(zyl_util_vue)

/** 全局组件开始 **/
import CompPage from '@/components/common/CompPage.vue'
import CompChooseCustomer from '@/components/common/CompChooseCustomer.vue'
import CompChooseMaterial from '@/components/common/CompChooseMaterial.vue'
import Breadcrumb from '@/components/common/Breadcrumb.vue'
import CompCopy from '@/components/common/CompCopy.vue'
Vue.component('CompPage',CompPage);
Vue.component('CompChooseCustomer',CompChooseCustomer);
Vue.component('CompChooseMaterial',CompChooseMaterial);
Vue.component('Breadcrumb',Breadcrumb);
Vue.component('CompCopy',CompCopy);
/** 全局组件结束 **/

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')